"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
function CardsVideoLayer(_a) {
    var id = _a.id, mediaId = _a.mediaId;
    var cards = ra_fetch_1.useApi('media').index('video_cards', {
        external_id: mediaId,
    })[0];
    function start(time) {
        var card = cards.data.findBy('start_seconds', time);
        if (!card.id) {
            return;
        }
        var card_id = "card-" + card.id;
        var existing = document.getElementById(card_id);
        if (existing) {
            return;
        }
        var html = "<div id=\"" + card_id + "\" class=\"storybook-timelines-video-card\">";
        html += "<h2>" + card.title + "</h2>";
        if (card.description) {
            html += "<small>" + card.description + "</small>";
        }
        if (card.url) {
            html += "<a href=\"" + card.url + "\" target=\"_blank\">" + card.url + "</a>";
        }
        html += '</div>';
        var player = document.getElementById(id);
        if (player) {
            player.insertAdjacentHTML('afterbegin', html);
        }
    }
    function end(time) {
        var card = cards.data.findBy('end_seconds', time);
        if (!card.id) {
            return;
        }
        var card_id = "card-" + card.id;
        var existing = document.getElementById(card_id);
        if (existing) {
            existing.remove();
        }
    }
    react_1.useEffect(function () {
        if (cards.data.length) {
            jwplayer().on('time', function (e) {
                var time = parseInt(e.currentTime.toFixed(0));
                start(time);
                end(time);
            });
            return function () { return jwplayer().off('time'); };
        }
    }, [cards.loading]);
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.default = CardsVideoLayer;
